export var CrudRequestType = /*#__PURE__*/function (CrudRequestType) {
  CrudRequestType["ReadOne"] = "ReadOne";
  CrudRequestType["ReadMany"] = "ReadMany";
  CrudRequestType["CreateOne"] = "CreateOne";
  CrudRequestType["CreateMany"] = "CreateMany";
  CrudRequestType["Update"] = "Update";
  CrudRequestType["Delete"] = "Delete";
  return CrudRequestType;
}(CrudRequestType || {});